import React from 'react';
import './App.css'
import { StateProvider } from './Context';
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom'
import Home from './Home';
import NoteView from './NoteView';



function App() {

  return (


    <>
      <StateProvider>
        <Router>
          <Switch>
            <Route path="/noteview/:id" component={NoteView} exact />
            <Route path="/" component={Home} exact />
          </Switch>
        </Router>
      </StateProvider>
    </>

  );
}

export default App;

